import React, { useState } from "react";
import { format, isValid, parse } from "date-fns";
import { nl, enGB } from "date-fns/locale";
import { usePage } from "@inertiajs/react";
import { Calendar } from "./calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Button } from "./button";
import { cn } from "../../lib/utils";

const locales = { nl, en: enGB };
const placeholders = { nl: "dd-mm-jjjj", en: "dd-mm-yyyy" };

function DatePicker({ value, onChange, name, className, captionLayout, startYear, endYear }) {
    const { locale: appLocale } = usePage().props;
    const placeholder = placeholders[appLocale] || placeholders.nl;
    const [open, setOpen] = useState(false);

    const selectedDate = value ? parse(value, "dd-MM-yyyy", new Date()) : undefined;
    const displayValue = isValid(selectedDate) ? format(selectedDate, "dd-MM-yyyy") : value || "";

    function handleDaySelect(date) {
        if (date) {
            onChange({ target: { name, value: format(date, "dd-MM-yyyy") } });
        } else {
            onChange({ target: { name, value: "" } });
        }
        setOpen(false);
    }

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    type="button"
                    className={cn(
                        "h-[40px] w-[110px] rounded-sm justify-start text-left text-sm font-normal",
                        !displayValue && "text-muted-foreground",
                        className
                    )}
                >
                    {displayValue || placeholder}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
                <Calendar
                    mode="single"
                    selected={isValid(selectedDate) ? selectedDate : undefined}
                    defaultMonth={isValid(selectedDate) ? selectedDate : undefined}
                    onSelect={handleDaySelect}
                    locale={locales[appLocale] || locales.nl}
                    {...(captionLayout && { captionLayout })}
                    {...(startYear && { startMonth: new Date(startYear, 0) })}
                    {...(endYear && { endMonth: new Date(endYear, 11) })}
                />
            </PopoverContent>
        </Popover>
    );
}

export { DatePicker };
